import { useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import useStyles from './index.styles';

import { ChatType } from '.';

const CustomerChatBody = ({ chats }: { chats: ChatType[] }) => {
  const classes = useStyles();
  const messageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'end',
      });
    }
  }, [chats.length]);

  return (
    <Box sx={{ padding: '1rem' }}>
      {chats.map((chat) => {
        return (
          <Box ref={messageRef} key={chat.id}>
            <Box
              sx={{
                justifyContent: chat.sender === 'agent' ? 'end' : 'start',
              }}
              className={classes.messageContainer}
            >
              {chat.sender === 'customer' && (
                <Box
                  sx={{
                    height: '30px',
                    width: '30px',
                    borderRadius: '50%',
                    backgroundColor: '#808080',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography color='#fff' mt='5px'>
                    C
                  </Typography>
                </Box>
              )}
              <Box maxWidth='60%'>
                {chat.messages.map((message, index) => (
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: chat.sender === 'agent' ? 'end' : 'start',
                    }}
                    key={`message-${index}`}
                  >
                    <Box
                      sx={{
                        filter: 'drop-shadow(0px 2px rgba(50, 71, 92, 0.04))',
                        borderRadius:
                          chat.sender === 'agent'
                            ? '6px 0 6px 6px'
                            : '0 6px 6px',
                        padding: '0.75rem',
                        background:
                          chat.sender === 'agent' ? '#6AC5AB' : '#FFFFFF',
                        marginBottom: '0.4rem',
                        display: 'inline-flex',
                      }}
                    >
                      <Typography
                        color={chat.sender === 'agent' ? '#fff' : '#32475CDE'}
                        fontSize='0.9rem'
                      >
                        {message}
                      </Typography>
                    </Box>
                  </Box>
                ))}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: chat.sender === 'agent' ? 'end' : 'start',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '0.8rem',
                      color: '#32475C61',
                      textTransform: 'uppercase',
                    }}
                  >
                    {moment(chat.timestamp).format('DD/MM/YY hh:mm a')}
                  </Typography>
                </Box>
              </Box>
              {chat.sender === 'agent' && (
                <Box
                  sx={{
                    height: '30px',
                    width: '30px',
                    borderRadius: '50%',
                    backgroundColor: '#6AC5AB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography color='#fff' mt='5px'>
                    A
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
export default CustomerChatBody;
